module.exports = __webpack_public_path__ + "img/loading-logo.cb56e8e4.png";